import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ResponseStatus} from "../../actions/types";
import orderGroupService from "../../services/order-group.service";
import {OrderGroupModel} from "../../pages/shared/models/order/orderGroupModel";
import {handleGetGroups, onPaginationChange} from "../reducers/order-group.reducer";

export const getOrderGroups = createAsyncThunk(
    'getOrderGroups',
    async (props :{forceLoad?: boolean, page?: number, orderStateId: number}, thunkApi) => {
        try {
            const state = (thunkApi.getState() as any).orderGroupReducer as OrderGroupSliceData;
            const filter = {
                orderStateId: props.orderStateId
            }
            const orderGroups = await orderGroupService.getGroups(filter, props.page || 0, state.data.pageSize);
            return {orderGroups}
        } catch (error) {
            return thunkApi.rejectWithValue(error)
        }},
        {
            condition(props :{forceLoad?: boolean, page?: number}, {getState}): boolean {
            const allSliceStates = getState() as {[key: string]: any};
            const orderGroupReducer = allSliceStates['orderGroupReducer'];

            return props.forceLoad || !(orderGroupReducer.data.groups && orderGroupReducer.data.groups.length);
        }
    }
)

export const orderGroupSlice = createSlice({
    name: "orderGroups",
    initialState: {
        data: {
            groups: [] as OrderGroupModel[],
            currentPage: 0,
            pageSize: 6,
            totalItems: 0,
        },
        errors: [],
        isLoading: false,
    } as OrderGroupSliceData,
    reducers: {
        changePagination: onPaginationChange
    },
    extraReducers: (builder) => {
        builder.addCase(getOrderGroups.pending, state => handleGetGroups(state, ResponseStatus.PENDING, null));
        builder.addCase(getOrderGroups.fulfilled, (state, action) => handleGetGroups(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getOrderGroups.rejected, (state, action) => handleGetGroups(state, ResponseStatus.FAIL, action.payload));
    }
})

export interface OrderGroupSliceData {
    data: {
        groups: OrderGroupModel[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    errors: any[],
    isLoading: boolean,
}

export default orderGroupSlice.reducer;
export const {changePagination} = orderGroupSlice.actions;
